export default "__VITE_ASSET__nvXuvppCMfySiGdrgEDnsA__"